import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full py-16 md:py-24 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20warm%20minimalist%20health%20wellness%20background%20with%20soft%20flowing%20organic%20lines%20in%20warm%20earthy%20green%20and%20golden%20tones%2C%20clean%20calming%20composition%2C%20professional%20medical%20atmosphere%2C%20subtle%20healing%20vibe&width=1600&height=600&seq=cta-bg-2026&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/25"></div>
      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-4">
          开始你的健康探索之旅
        </h2>
        <p className="text-sm md:text-base text-background-50/85 max-w-lg mx-auto mb-8 leading-relaxed">
          科学认识前列腺，是对自身健康负责的第一步。浏览我们的专业文章，获取经过医学审核的可靠知识。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/techniques"
            className="px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full font-medium text-sm transition-colors whitespace-nowrap cursor-pointer"
          >
            浏览方法与技巧
            <i className="ri-guide-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="px-6 py-3 bg-background-50/20 hover:bg-background-50/30 text-background-50 backdrop-blur-sm rounded-full font-medium text-sm transition-colors whitespace-nowrap cursor-pointer border border-background-50/30"
          >
            了解更多
            <i className="ri-information-line ml-2"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}